import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { motion } from 'framer-motion';
import { Settings } from 'lucide-react';

const AdvancedOptionsNode = ({ id, data }) => {
  const { 
    idregistrationfees, 
    idreferrallevels, 
    notarizationreward,
    blocktime,
    powaveragingwindow,
    onUpdate 
  } = data;

  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className="bg-slate-800 rounded-xl border-2 border-cyan-500/50 shadow-xl min-w-[320px]"
    >
      {/* Header */}
      <div className="bg-gradient-to-r from-cyan-500 to-blue-600 rounded-t-lg px-4 py-3">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center">
            <Settings className="w-5 h-5 text-white" />
          </div>
          <div>
            <h3 className="font-semibold text-white text-sm">Advanced Options</h3>
            <p className="text-white/70 text-xs">Chain parameters</p>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="p-4 space-y-3">
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-medium text-slate-400 mb-1.5">
              ID Registration Fee
            </label>
            <input
              type="number"
              value={idregistrationfees ?? 100}
              onChange={(e) => onUpdate?.({ idregistrationfees: parseFloat(e.target.value) || 0 })}
              className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500/50"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-400 mb-1.5">
              Referral Levels
            </label>
            <select
              value={idreferrallevels ?? 3}
              onChange={(e) => onUpdate?.({ idreferrallevels: parseInt(e.target.value) })}
              className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500/50"
            >
              <option value={1}>1 Level</option>
              <option value={2}>2 Levels</option>
              <option value={3}>3 Levels</option>
            </select>
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-400 mb-1.5">
            Notarization Reward
          </label>
          <input
            type="number"
            step="0.0001"
            value={notarizationreward ?? 0.0001}
            onChange={(e) => onUpdate?.({ notarizationreward: parseFloat(e.target.value) || 0 })}
            className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500/50"
          />
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-medium text-slate-400 mb-1.5">
              Block Time (sec)
            </label>
            <input
              type="number"
              value={blocktime ?? 60}
              onChange={(e) => onUpdate?.({ blocktime: parseInt(e.target.value) || 60 })}
              className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500/50"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-400 mb-1.5">
              PoW Averaging
            </label>
            <input
              type="number"
              value={powaveragingwindow ?? 45}
              onChange={(e) => onUpdate?.({ powaveragingwindow: parseInt(e.target.value) || 45 })}
              className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500/50"
            />
          </div>
        </div>
      </div>

      {/* Handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="!w-3 !h-3 !bg-cyan-500 !border-2 !border-slate-800"
      />
    </motion.div>
  );
};

export default AdvancedOptionsNode;
